// localStorage key + URL query param used by the affiliate / referral
// flow. Captured in `app/_providers/app-providers.tsx` whenever a `?r=…`
// query param is detected (during a user's first session) and consumed by
// `components/SubmitVideoForm.tsx` when a project is created so the
// referral can be attributed to the right partner.
export const REFERRAL_CODE_KEY = "referral_code";
export const REFERRAL_QUERY_PARAM = "r";
